import type { TradeInAemNavStep } from "../../utils/constants";

export const TRADE_IN_AEM_NAV_SET_STEP = "tradeInAemNav/setStep";

export type TradeInAemSetStepType = {
    type: typeof TRADE_IN_AEM_NAV_SET_STEP;
    step: TradeInAemNavStep;
};

export const tradeInAemSetStep = (step: TradeInAemNavStep): TradeInAemSetStepType => ({
    type: TRADE_IN_AEM_NAV_SET_STEP,
    step,
});

export type TradeInAemNavActionsType = TradeInAemSetStepType;
